
<template>
  <div class="app">
    <page-header/>
    <router-view/>
  </div>
</template>
<style lang="scss" scoped>
.app {
  height: 100vh;
}
</style>

<script>
import PageHeader from './components/PageHeader'
export default {
  components: {
    PageHeader
  }
}
</script>

<style>
</style>
